<div class="auth-page">
  <div class="auth-wrapper">
    <div class="auth-brand">
      <img src="logo.svg" alt="Every Rupee Spent logo" width="28" height="28" />
      <span>Every Rupee Spent</span>
    </div>
    <mat-card class="auth-card">
      <mat-card-header>
        <mat-card-title>Forgot password</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p class="auth-hint">Enter your account email and we'll send you a code to reset your password.</p>
        <form [formGroup]="form" (ngSubmit)="submit()">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Email</mat-label>
            <input matInput type="email" formControlName="email" autocomplete="email" />
            @if (form.controls.email.hasError('required')) {
              <mat-error>Email is required</mat-error>
            } @else if (form.controls.email.hasError('email')) {
              <mat-error>Enter a valid email address</mat-error>
            }
          </mat-form-field>

          @if (errorMessage(); as msg) {
            <p class="error-message">{{ msg }}</p>
          }

          <button mat-flat-button color="primary" type="submit" class="full-width" [disabled]="loading()">
            @if (loading()) {
              <mat-spinner diameter="20" />
            } @else {
              Send reset code
            }
          </button>
        </form>
      </mat-card-content>
      <mat-card-footer class="auth-footer">
        <a routerLink="/login">Back to log in</a>
      </mat-card-footer>
    </mat-card>
    <footer class="page-footer">© {{ currentYear }} everyrupeespent.com</footer>
  </div>
</div>
